export default "__VITE_ASSET__Dnyefsn4__"